import objectFitImages from 'object-fit-images';
import ResizeObserver from './utils/resize-observer';
import ScrollObserver from './utils/scroll-observer';
import select from './utils/select';

import Minimaps from './utils/minimaps';
import Scroller from './utils/scroller';

const leadArt = select('#lead-art');
const masthead = select('.masthead');
const mastheadHeight = masthead.getBoundingClientRect().height;

const onResize = new ResizeObserver();
const whenScroll = new ScrollObserver();

// masthead background handler
whenScroll.add(() => {
  const rect = leadArt.getBoundingClientRect();

  if (rect.bottom - mastheadHeight * 0.75 < 0) {
    masthead.classList.add('masthead--background');
  } else {
    masthead.classList.remove('masthead--background');
  }
});

/*
Kickstart the scroll watcher in case it's reloaded in the middle of the page
 */
whenScroll.onScroll();

if (select('.dv-gpt-ad') != null) {
  import(/* webpackChunkName: "adloader" */ './utils/ad-loader').then(
    module => {
      const AdLoader = module.default;

      const loader = new AdLoader({ targetingValue: 'harvey-reservoirs' });
      loader.init();
    }
  );
}

if (select('img.lazyload') != null) {
  import(/* webpackChunkName: "lazyload" */ './utils/lazyload').then(module => {
    const LazyLoad = module.default;

    const ll = new LazyLoad({ scrollObserver: whenScroll });
    ll.init();

    objectFitImages('img.js-lazyload-img');
  });
}

const minimaps = new Minimaps({ resizeObserver: onResize });
minimaps.init();

const scroller = new Scroller({ resizeObserver: onResize });
scroller.init();

export default () => {};



// WEBPACK FOOTER //
// ./main.js